import React from "react";
import { Wrench, RefreshCw, ExternalLink } from "lucide-react";
import { useTheme } from "../context/ThemeContext";

export default function MaintenancePage() {
  const { theme } = useTheme();
  const gridColor = theme === "light" ? "rgba(0,0,0,0.04)" : "rgba(255,255,255,0.025)";
  return (
    <div className="min-h-screen flex flex-col items-center justify-center px-6" style={{ background: "var(--c-bg)" }} data-testid="maintenance-page">
      {/* Background grid */}
      <div className="absolute inset-0 pointer-events-none"
        style={{ backgroundImage: `linear-gradient(${gridColor} 1px, transparent 1px), linear-gradient(90deg, ${gridColor} 1px, transparent 1px)`, backgroundSize: "80px 80px" }} />

      <div className="relative max-w-md w-full text-center space-y-6">
        {/* Icon */}
        <div className="inline-flex items-center justify-center w-16 h-16 rounded-2xl bg-amber-500/10 border border-amber-500/20 mx-auto">
          <Wrench size={28} className="text-amber-400" strokeWidth={1.5} />
        </div>

        {/* Logo */}
        <div className="font-mono text-lg font-bold">
          <span className="text-[#00ff88]">Scrape</span><span className="text-zinc-500">Core</span>
        </div>

        {/* Heading */}
        <div>
          <h1 className="text-2xl font-bold font-head mb-3" style={{ color: "var(--c-text)" }}>System Maintenance</h1>
          <p className="text-sm leading-relaxed" style={{ color: "var(--c-text-2)" }}>
            We're performing scheduled maintenance to improve your experience.
            The platform will be back online shortly.
          </p>
        </div>

        {/* Status */}
        <div className="flex items-center justify-center gap-2 px-4 py-3 bg-amber-500/5 border border-amber-500/20 rounded-xl text-sm font-mono text-amber-500" data-testid="maintenance-status">
          <span className="w-2 h-2 rounded-full bg-amber-500 animate-pulse" />
          Maintenance in progress
        </div>

        {/* Actions */}
        <div className="flex flex-col gap-3">
          <button
            onClick={() => window.location.reload()}
            className="flex items-center justify-center gap-2 w-full px-4 py-2.5 border border-zinc-800 text-sm font-mono transition-colors hover:border-zinc-600"
            style={{ color: "var(--c-text-2)" }}
            data-testid="maintenance-refresh-btn"
          >
            <RefreshCw size={14} /> Try again
          </button>
          <a
            href="/admin"
            className="flex items-center justify-center gap-2 w-full px-4 py-2.5 text-xs font-mono transition-colors"
            style={{ color: "var(--c-text-4)" }}
            data-testid="maintenance-admin-link"
          >
            <ExternalLink size={12} /> Admin access
          </a>
        </div>

        {/* Footer */}
        <p className="text-xs font-mono" style={{ color: "var(--c-text-4)" }}>
          Follow{" "}
          <a href="https://status.scrapecore.com" className="underline" style={{ color: "var(--c-text-3)" }}>
            status.scrapecore.com
          </a>{" "}
          for live updates
        </p>
      </div>
    </div>
  );
}
